// @ts-expect-error missing types
import initReactivesearch from "@usereactify/search-internals/lib/server";

import { getConfig } from "./config";
import { getPropsBase, getPropsFilterGroup } from "./props";
import { ReactifySearchProviderProps } from "../components";
import { getFilterStack } from "./filters";

export const generateProviderProps = async (options: ReactifySearchProviderProps & { query: Record<string, string> }): Promise<ReactifySearchProviderProps> => {
  const config = await getConfig(options.shopifyPermanentDomain);

  const filterStack = getFilterStack({
    provider: options,
    config: config
  });

  const props = getPropsFilterGroup({
    provider: options,
    config: config,
    filterGroup: filterStack,
    query: options.query,
  });

  return {
    ...options,
    preload: {
      config: config,
      state: await initReactivesearch(props, options.query, getPropsBase({
        config: config,
        provider: options,
        query: options.query,
      }))
    }
  }
}